import { IonCol, IonItem, IonText } from '@ionic/react';
import React from 'react';
import HealthRecommendation, { HealthRecommendationProps } from '../../components/HealthRecommendation';
import { useSettings } from '../../contexts/SettingsContext';
import * as commonCss from '../../styles/common';
import { BaseSection } from '../BaseSection';

export const HealthRecommendationSection: React.FC = () => {
  const { aqiLevel, marker } = useSettings();
  const recommendations: HealthRecommendationProps[] = React.useMemo(
    () =>
      aqiLevel?.recommendations.map(({ iconId, text }) => ({
        recommendationText: text,
        iconName: iconId as HealthRecommendationProps['iconName'],
        color: aqiLevel.color,
      })) ?? [],
    [aqiLevel]
  );

  const component = (
    <>
      {recommendations.map(({ recommendationText, iconName, color }) => (
        <IonCol key={recommendationText} size="12">
          <HealthRecommendation color={color} iconName={iconName} recommendationText={recommendationText} />
        </IonCol>
      ))}
    </>
  );

  const emptyComponent = (
    <IonItem lines="none">
      <IonText css={[commonCss.italics, commonCss.smallText]}>No recommendations available.</IonText>
    </IonItem>
  );

  return (
    <BaseSection title="Health Recommendations">
      {!marker || marker.isStale || recommendations.length === 0 ? emptyComponent : component}
    </BaseSection>
  );
};
